// extracted by mini-css-extract-plugin
export default {"howDoTraders":"HowDoTraders_howDoTraders__zub5a","title":"HowDoTraders_title__O9ohx","content":"HowDoTraders_content__nntCS","text":"HowDoTraders_text__0eAul"};